import { useState } from 'react'
import { FibaDatePicker, FibaDropdown, Form, ListScreen, send, useFibaMsgBox, useLoading } from '../../components'
import { GridColumn } from '@progress/kendo-react-grid'
import { useTranslation } from 'react-i18next'
import { ORDER_DETAIL } from '../../constants/data.const'
import { Dialog } from "@progress/kendo-react-dialogs";
import { dateFormat } from '../../components/service/functions'
import { Field } from '@progress/kendo-react-form'
import FibaButton from '../../components/button/FibaButton/FibaButton'

const Order = () => {
  const { t } = useTranslation()
  const { error } = useFibaMsgBox()
  const [modalState, setmodalState] = useState(false)
  const { showLoading } = useLoading()

  const exportExcel = async (data) => {
    const res = await send('ve000001', data, showLoading);
    if (res.status === 'error') {
      error(res.message)
    } else {
      const downloadLink = document.createElement("a");
      downloadLink.href = res;
      downloadLink.download = `${data.createddatestart} - ${data.createddateend} захиалга.xlsx`;
      downloadLink.click();
    }
  }

  return (
    <div>
      <ListScreen
        read={'vo000001'}
        selectedFieldName={"code"}
        createable={false}
        deleteable={false}
        customFunction={() => {
          setmodalState(true)
        }}
        customFunctionText={"EXCEL"}
      >
        <GridColumn field='code' title={t('code')} filter='text' />
        <GridColumn field='price' title={t('price')} filter='numeric' />
        <GridColumn field='userid' title={t('userid')} filter='numeric' />
        <GridColumn field='phone' title={t('phone')} filter='text' />
        <GridColumn field='last_name' title={t('last_name')} filter='text' />
        <GridColumn field='first_name' title={t('first_name')} filter='text' />
        <GridColumn field='delivery' title={t('delivery')} filter='text' />
        <GridColumn field='statusid' title={t('statusid')} filterType='select' constData={ORDER_DETAIL} />
        <GridColumn field='created_at' title={t('created_at')} filter='date' />
      </ListScreen>
      {modalState && (
        <Dialog
          title={t("search")}
          onClose={() => { setmodalState(false) }}
          width={"300px"}
          height={"auto"}
        >
          <Form
            onSubmit={exportExcel}
            showAction={false}
            initialValues={{
              createddatestart: dateFormat(new Date()),
              createddateend: dateFormat(new Date()),
            }}
            ignoreModified={true}
          >
            <div className='mt-2'>
              <Field
                name={'createddatestart'}
                component={FibaDatePicker}
                label={t('Эхлэх огноо')}
                required={true}
              />
            </div>
            <div className='mt-2'>
              <Field
                name={'createddateend'}
                component={FibaDatePicker}
                label={t('Дуусах огноо')}
                required={true}
              />
            </div>
            <div className='my-2'>
              <Field
                name={'status'}
                component={FibaDropdown}
                label={t('status')}
                data={ORDER_DETAIL}
              />
            </div>
            <div className='flex justify-center'>
              <FibaButton className={'my-2 w-[200px] text-center mx-auto'} type='submit'>Хайх</FibaButton>
            </div>
          </Form>
        </Dialog>
      )}
    </div>

  )
}

export default Order